<script setup lang="ts">
import { useVariablesForMentions } from '@/composables/queries/variables/useVariablesForMentions'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  fields: string[]
  placeholders: string[]
}>()

const { t } = useI18n()
const { variables, tooltipLabels, missingBadgeTooltip, invalidBadgeTooltip } =
  useVariablesForMentions()

const modelValue = defineModel<Record<string, string>[]>({ default: () => [] })
</script>

<template>
  <OMultiInput
    v-model="modelValue"
    :scrollable="false"
    :add-label="t('add_phrase')"
    add-mode="progressive"
    textarea-mentions-size="L"
    v-bind="$attrs"
    :fields="props.fields"
    :placeholders="props.placeholders"
    :field-types="['textarea-mentions']"
    :field-mentions-options="[variables]"
    :field-mentions-dropdown-title="[t('variables.dropdown_title')]"
    :field-mentions-tooltip-labels="tooltipLabels"
    :field-mentions-missing-badge-tooltip="missingBadgeTooltip"
    :field-mentions-error-badge-tooltip="invalidBadgeTooltip"
  />
</template>
